<template>
  <div>
    <div class="fix-top">
      <router-link tag="div" to="/personal/coupon/spec">
        <div class="spec"><i class="iconfont icon-tishi"></i>golo课堂优惠券使用说明</div>
      </router-link>
      <div class="coupon-search">
        <div>
          <div class="col-1">
            <input type="text" placeholder="输入兑换码" v-model="couponCode" @focus="handleFocus">
          </div>
          <div class="col-2"  @click="_getCouponByCode">
            <i class="iconfont icon-iconfontzhizuobiaozhun22"></i>
          </div>
        </div>
      </div>
      <!--<div class="dh-coupon">-->
        <!--<coupon-card :data="coupon"></coupon-card>-->
      <!--</div>-->
      <nav-tab>
        <template>
          <router-link tag="div" to="unused" class="tab" replace >
            <span>未使用 {{num[1]?num[1]:''}}</span>
          </router-link>
          <router-link tag="div" to="used" class="tab" replace >
            <span>已使用 {{num[2]?num[2]:''}}</span>
          </router-link>
          <router-link tag="div" to="past" class="tab" replace >
            <span>过期 {{num[3]?num[3]:''}}</span>
          </router-link>
        </template>
      </nav-tab>
    </div>
    <router-view @data="ondata"></router-view>
  </div>
</template>
<script type="text/ecmascript-6">
import NavTab from '@/components/base/nav-tab/nav-tab'
import CouponCard from './coupon-card'
import {getCouponByCode} from '@/api/user-center.js'
import {RES_OK} from '@/api/config'
export default {
  components: {
    NavTab,
    CouponCard
  },
  data() {
    return {
      num: {}, // 每种券的数量
      couponCode: ''
    }
  },
  created() {
  },
  methods: {
    ondata(data) {
      this.num = data
    },
    _getCouponByCode() {
      if (!this.couponCode) {
        this.$toast('请输入兑换码')
        return
      }
      getCouponByCode(this.couponCode).then(res => {
        let data = res.data
        if (data && data.code === RES_OK) {
          this.$router.replace('/personal/coupon/unused')
        }
        this.$toast(data.msg)
      }).catch(err => {
        console.log(err)
      })
    },
    handleFocus() {
      this.$router.replace('./unused')
    },
    handleBlur() {
      console.log('失去焦点')
    },
    handleTouchEnd(e) {
      console.log(e)
      e.preventDefault()
      console.log('点击搜索按钮')
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .fix-top
    background #ffffff
    position fixed
    left 0
    top 0
    width 100%
    z-index 9
  .spec
    height size(40)
    background #fff7e2
    font-size size(24)
    color #666
    line-height size(40)
    padding 0 size(30)
    .iconfont
      font-size size(26)
      padding-right size(10)
      vertical-align middle
  .coupon-search {
    padding: 0 size(32)
    margin-top size(20)
    margin-bottom: size(14)
    >div{
      display flex
      flex-wrap nowrap
      flex-direction row
      justify-content space-between
      align-items center
      width: 100%
      height size(62)
      background-color: #f5f5f5
      overflow hidden
      -webkit-border-radius: size(31)
      -moz-border-radius: size(31)
      border-radius: size(31)
      padding: 0 size(40)
    }
    .col-1{
      width: calc(100% - size(40))
      height: 100%;
      input{
        width: 100%
        height: 100%
        font-size size(26)
        outline none
        background-color: transparent
        &::placeholder{
          color: #949494;
        }
      }
    }
    .col-2{
      width: size(40)
      text-align right
    }
  }
  .dh-coupon{
    padding: size(20) size(40)
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/coupon/coupon.vue